export default __webpack_public_path__ + "static/media/wanna1.79eba30d.png";